import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _styled from "styled-components";
import { Timeline as FlowBiteTimeLine } from 'flowbite-react';
import { getAssetSrc } from '@restworld/utils-common';
import { ArrowDownCircleIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Item = FlowBiteTimeLine.Item,
    Content = FlowBiteTimeLine.Content,
    Title = FlowBiteTimeLine.Title,
    Body = FlowBiteTimeLine.Body;
export var TimelineV2 = function TimelineV2(_ref) {
  var timeLineSteps = _ref.timeLineSteps;
  return /*#__PURE__*/_jsx(FlowBiteTimeLineStyled, {
    children: timeLineSteps.map(function (_ref2, i, list) {
      var title = _ref2.title,
          subtitle = _ref2.subtitle,
          checked = _ref2.checked,
          isFlagged = _ref2.isFlagged,
          showDownIcon = _ref2.showDownIcon,
          customContentElement = _ref2.customContentElement,
          verticalLineStyle = _ref2.verticalLineStyle;
      return /*#__PURE__*/_jsxs(ItemStyled, {
        twstyle: [verticalLineStyle === 'dashed' ? {
          "borderStyle": "dashed",
          "--tw-border-opacity": "1",
          "borderColor": "rgb(117 117 131 / var(--tw-border-opacity))"
        } : {}, i === list.length - 1 ? {
          "paddingBottom": "0px"
        } : {}],
        children: [/*#__PURE__*/_jsx(FlowBiteTimeLinePointStyled, {
          theme: {},
          icon: function icon() {
            return isFlagged ? /*#__PURE__*/_jsx("img", {
              src: getAssetSrc('/utils-assets/flag-checkmark.svg'),
              alt: ""
            }) : showDownIcon ? /*#__PURE__*/_jsx(ArrowDownCircleIcon, {
              className: "h-5 w-5 text-neutral-100"
            }) : checked ? /*#__PURE__*/_jsx(CheckCircleIcon, {
              className: "h-5 w-5 text-purple-500"
            }) : /*#__PURE__*/_jsx(TimeLineIcon, {
              children: i + 1
            });
          }
        }), customContentElement || /*#__PURE__*/_jsxs(Content, {
          children: [/*#__PURE__*/_jsx(TitleStyled, {
            children: title
          }), subtitle ? /*#__PURE__*/_jsx(BodyStyled, {
            children: subtitle
          }) : null]
        })]
      }, title);
    })
  });
};
export default TimelineV2;

var FlowBiteTimeLineStyled = /*#__PURE__*/_styled(FlowBiteTimeLine).withConfig({
  displayName: "timeline-v2__FlowBiteTimeLineStyled",
  componentId: "sc-1j14kq-0"
})(["", ";"], {
  "borderStyle": "none"
});

var FlowBiteTimeLinePointStyled = /*#__PURE__*/_styled(FlowBiteTimeLine.Point).withConfig({
  displayName: "timeline-v2__FlowBiteTimeLinePointStyled",
  componentId: "sc-1j14kq-1"
})(["span{", "}"], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
});

var ItemStyled = /*#__PURE__*/_styled(Item).withConfig({
  displayName: "timeline-v2__ItemStyled",
  componentId: "sc-1j14kq-2"
})(function (_ref3) {
  var twstyle = _ref3.twstyle;
  return [{
    "marginBottom": "0px",
    "marginLeft": "0px",
    "paddingBottom": "2rem",
    "paddingLeft": "1.5rem"
  }, {
    "borderLeftWidth": "1px",
    "borderStyle": "solid",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 51 187 / var(--tw-border-opacity))"
  }].concat(_toConsumableArray(twstyle || []));
});

var TitleStyled = /*#__PURE__*/_styled(Title).withConfig({
  displayName: "timeline-v2__TitleStyled",
  componentId: "sc-1j14kq-3"
})({
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});

var BodyStyled = /*#__PURE__*/_styled(Body).withConfig({
  displayName: "timeline-v2__BodyStyled",
  componentId: "sc-1j14kq-4"
})({});

var TimeLineIcon = /*#__PURE__*/_styled.span.withConfig({
  displayName: "timeline-v2__TimeLineIcon",
  componentId: "sc-1j14kq-5"
})({});